import { PageName } from './types';

let currentPageName: PageName = 'Unknown';

export const getCurrentPageName = (): PageName => currentPageName;

export const setCurrentPageName = (pageName: PageName): void => {
  currentPageName = pageName;
};
